 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'doctorAdd'" @click="addGroup">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">运营组名称：</span>
                <el-input v-model="group_name" placeholder="运营组名称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">所属公司：</span>
                <el-select
                    clearable
                    v-model="company_id" placeholder="请选择所属公司"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allCompany"
                            :key="item.id"
                            :label="item.company_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">所属部门：</span>
                <el-select
                    clearable
                    v-model="department_id" placeholder="请选择所属部门"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allCompanyDeparment"
                            :key="item.id"
                            :label="item.department_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    v-model="status" placeholder="请选择状态"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="group_name" label="运营组名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="admin_user_name" label="组长" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="company_name" label="所属公司" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="department_name" label="所属部门" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="160" prop="number" label="特属服务专员人数" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'doctorEdit'" @click="deleteHealthrecords(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopCompanyDeparment(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopCompanyDeparment(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                group_name: '',
                company_id: '',
                department_id: '',
                status: '',
                allCompany: [],
                allCompanyDeparment: [],
                button_position: 'absolute',
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            if (this.$route.params.department_id) {
                this.department_id = this.$route.params.department_id;
            }
            if (this.$route.query.department_id) {
                this.department_id = this.$route.query.department_id;
            }
        },
        mounted() {
            // 获取组列表
            this.getList();
            this.getAllCompany();
            this.getAllCompanyDeparment();
            localStorage.setItem('prev_page', 'group_list')
        },
        methods: {
            getList() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'companyGroupListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        group_name: this.group_name,
                        company_id: this.company_id,
                        department_id: this.department_id,
                        status: this.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            getAllCompany() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'deparmentListingParams',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data;
                });
            },

            getAllCompanyDeparment() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyDeparment',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyDeparment = res.data.data;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.group_name = "";
                this.company_id = "";
                this.department_id = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "groupEdit", params: {
                        id: data.id,
                        sort: data.sort,
                        group_name: data.group_name,
                        status: parseInt(data.status_number),
                        company_id: data.company_id,
                        department_id: data.department_id,
                        admin_id:data.admin_id,
                    }
                });

            },

            // 新增运营组
            addGroup() {
                this.$router.push({name: "groupAdd", params: {}});
            },

            deleteHealthrecords(data) {
                this.$confirm('确定删除该运营组吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'deleteCompanyGroup',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 启用停用公司
            startStopCompanyDeparment(data, status) {
                if (status == '1') {
                    var message = '确定启用该运营组吗？';
                }
                if (status == '2') {
                    var message = '确定停用该运营吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'startStopCompanyGroup',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                    });
                }).catch(() => {
                });
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'exportCompanyGroup',
                    params: {
                        group_name: this.group_name,
                        company_id: this.company_id,
                        department_id: this.department_id,
                        status: this.status,
                    }
                };
                let colums_list = [
                    {title: "排序", key: "sort"},
                    {title: "运营组名称", key: "group_name"},
                    {title: "所属公司", key: "company_name"},
                    {title: "所属部门", key: "department_name"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            sort: res_data.data[i].sort,
                            group_name: res_data.data[i].group_name,
                            company_name: res_data.data[i].company_name,
                            department_name: res_data.data[i].department_name,
                            number: res_data.data[i].number,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出运营组");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
